import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6e09c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_invoices"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header w-100 pt-10\" data-v-e6e09c2e><div class=\"row w-100\" data-v-e6e09c2e><div class=\"col-12 col-lg-6 col-md-6 col-sm-12\" data-v-e6e09c2e><div class=\"card-title m-0\" data-v-e6e09c2e><h3 class=\"fw-bolder m-0\" data-v-e6e09c2e>Invoices</h3></div></div></div></div>", 1)
const _hoisted_3 = { class: "w-100 d-flex flex-column px-10 pb-10 pt-10" }
const _hoisted_4 = {
  key: 0,
  class: "card-body d-flex flex-column px-0 pt-0"
}
const _hoisted_5 = { class: "w-100 d-flex flex-column px-10 pb-10 pt-10" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href", "download"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Choose Your Plan")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row gap-2" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PlanColumnView = _resolveComponent("PlanColumnView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.loadingDetails)
      ? (_openBlock(), _createBlock(_component_el_skeleton, { key: 0 }, {
          template: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_skeleton, {
                variant: "text",
                rows: 6,
                animated: ""
              })
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.hasSubscription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (!_ctx.loadingInvoices)
                    ? (_openBlock(), _createBlock(_component_DataTable, {
                        key: 0,
                        "table-data": _ctx.invoiceLists,
                        "table-header": _ctx.headers
                      }, {
                        "cell-number": _withCtx(({ row: invoice }) => [
                          _createElementVNode("a", {
                            href: invoice?.hosted_invoice_url,
                            target: "_blank",
                            class: "text-gray-600 text-hover-primary"
                          }, _toDisplayString(invoice.number), 9, _hoisted_6)
                        ]),
                        "cell-amount": _withCtx(({ row: invoice }) => [
                          _createTextVNode(_toDisplayString(_ctx.moneyFormat(invoice.total)), 1)
                        ]),
                        "cell-status": _withCtx(({ row: invoice }) => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", {
                      'badge-light-success': invoice.status === 'paid',
                    }])
                          }, _toDisplayString(invoice.status), 3)
                        ]),
                        "cell-date": _withCtx(({ row: invoice }) => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(invoice.created, 'DD/MM/YYYY')), 1)
                        ]),
                        "cell-action": _withCtx(({ row: invoice }) => [
                          _createElementVNode("a", {
                            href: invoice.invoice_pdf,
                            download: `${invoice.number}.pdf`,
                            class: "btn btn-sm btn-light btn-active-light-primary"
                          }, " Download ", 8, _hoisted_7)
                        ]),
                        _: 1
                      }, 8, ["table-data", "table-header"]))
                    : (_openBlock(), _createBlock(_component_el_skeleton, {
                        key: 1,
                        rows: 5,
                        animated: ""
                      }))
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_8,
                _createVNode(_component_PlanColumnView)
              ], 64))
        ], 64))
  ]))
}